{
  "familyId": "TAA-LEZEN-KERN",
  "questions": [
    {
      "id": "TAA-LEZEN-KERN-001",
      "familyId": "TAA-LEZEN-KERN",
      "module": "Taalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_hoofdgedachte",
      "questionType": "multiple_choice",
      "context": "Bijen zijn heel belangrijk voor de natuur. Ze bestuiven bloemen, waardoor planten vruchten kunnen maken. Zonder bijen zouden veel gewassen niet groeien. Helaas gaat het niet goed met de bijen: door bestrijdingsmiddelen en minder bloemen sterven er steeds meer.",
      "question": "Wat is de hoofdgedachte van deze tekst?",
      "options": ["Bijen zijn belangrijk voor de natuur, maar het gaat niet goed met ze.", "Bijen maken honing voor de mens.", "Bestrijdingsmiddelen zijn slecht voor alle insecten.", "Planten hebben water nodig om te groeien."],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Hoofdgedachte bepalen",
            "content": "De hoofdgedachte vat de hele tekst samen in één zin. Zoek de rode draad die door alle zinnen loopt. Deze tekst heeft twee hoofdpunten: (1) bijen zijn belangrijk voor bestuiving, en (2) het gaat slecht met bijen.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "main_idea_text",
      "variantIndex": 1,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "De hoofdgedachte vat de hele tekst samen in één zin. De tekst noemt twee hoofdpunten: (1) bijen zijn belangrijk voor bestuiving en gewassen, en (2) het gaat slecht met bijen door bestrijdingsmiddelen en minder bloemen. Het juiste antwoord combineert beide punten.",
        "solutionSteps": [
          "Zoek de rode draad: waar gaat de hele tekst over?",
          "Hoofdpunt 1: bijen zijn belangrijk voor bestuiving",
          "Hoofdpunt 2: het gaat slecht met bijen",
          "De hoofdgedachte combineert beide: bijen zijn belangrijk, maar bedreigd"
        ],
        "distractorExplanations": {
          "0": "Goed! Dit antwoord combineert beide hoofdpunten: het belang van bijen én het gevaar dat ze bedreigt.",
          "1": "Je dacht waarschijnlijk dat bijen vooral om honing gaan. Maar honing wordt helemaal niet in de tekst genoemd. De tekst gaat over bestuiving, niet over honing. Onthoud: de hoofdgedachte staat in de tekst, niet in je eigen kennis.",
          "2": "Je dacht waarschijnlijk dat het detail over bestrijdingsmiddelen de hoofdgedachte is. Maar bestrijdingsmiddelen worden als één oorzaak genoemd. De tekst gaat breder: over het belang van bijen én de bedreigingen. Onthoud: een detail is niet de hoofdgedachte.",
          "3": "Je dacht waarschijnlijk dat planten en water erbij horen. Maar water wordt niet in de tekst genoemd. De tekst gaat over bijen en bestuiving. Onthoud: de hoofdgedachte staat in de tekst, niet erbuiten."
        }
      }
    },
    {
      "id": "TAA-LEZEN-KERN-002",
      "familyId": "TAA-LEZEN-KERN",
      "module": "Taalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_hoofdgedachte",
      "questionType": "multiple_choice",
      "context": "Nederland ligt voor een groot deel onder zeeniveau. Daarom zijn er dijken gebouwd om het water tegen te houden. Na de watersnoodramp van 1953 werden de Deltawerken aangelegd. Dit zijn enorme dammen en stormvloedkeringen die Zuid-Holland en Zeeland beschermen.",
      "question": "Welke samenvatting past het best bij deze tekst?",
      "options": ["Nederland beschermt zich met dijken en Deltawerken tegen het water, vooral na de ramp van 1953.", "De Deltawerken zijn de grootste bouwwerken ter wereld.", "In 1953 was er een watersnoodramp die heel Nederland verwoestte.", "Nederland ligt boven zeeniveau en heeft geen last van water."],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Goede samenvatting herkennen",
            "content": "Een goede samenvatting bevat alle hoofdpunten zonder details toe te voegen of weg te laten. Deze tekst heeft drie hoofdpunten: (1) Nederland ligt laag, (2) er zijn dijken en Deltawerken, (3) de aanleiding was 1953.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "text_summarization",
      "variantIndex": 2,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Een goede samenvatting bevat alle hoofdpunten zonder overdrijving. De tekst noemt: (1) Nederland ligt laag (onder zeeniveau), (2) er zijn dijken en Deltawerken gebouwd, (3) de aanleiding was de watersnoodramp van 1953. Antwoord A bevat al deze punten.",
        "solutionSteps": [
          "Zoek de hoofdpunten: (1) Nederland ligt laag, (2) dijken en Deltawerken, (3) ramp van 1953",
          "Controleer elk antwoord: bevat het alle hoofdpunten?",
          "Antwoord A bevat alle drie de punten zonder overdrijving ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Dit antwoord bevat alle hoofdpunten van de tekst zonder overdrijving.",
          "1": "Je dacht waarschijnlijk dat dit in de tekst staat. Maar de tekst zegt niet dat de Deltawerken de grootste bouwwerken ter wereld zijn. Dat is een toevoeging die niet in de bron staat. Onthoud: een samenvatting voegt niets toe.",
          "2": "Je dacht waarschijnlijk dat heel Nederland verwoest werd. Maar de tekst zegt dat de ramp vooral Zuid-Holland en Zeeland trof, niet heel Nederland. Dat is een overdrijving. Onthoud: een samenvatting overdrijft niet.",
          "3": "Je dacht waarschijnlijk dat dit klopt. Maar de tekst zegt juist het tegenovergestelde: Nederland ligt voor een groot deel ONDER zeeniveau. Onthoud: lees de tekst zorgvuldig voordat je een samenvatting kiest."
        }
      }
    },
    {
      "id": "TAA-LEZEN-KERN-003",
      "familyId": "TAA-LEZEN-KERN",
      "module": "Taalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_hoofdgedachte",
      "questionType": "multiple_choice",
      "context": "Steeds meer scholen gebruiken tablets in de klas. Leerlingen kunnen er spelletjes mee spelen die hen helpen met rekenen en taal. Maar er zijn ook nadelen: sommige kinderen worden afgeleid en kijken te lang naar een scherm. Leraren moeten daarom goed nadenken over wanneer ze tablets inzetten.",
      "question": "Wat is de hoofdgedachte van deze tekst?",
      "options": ["Tablets op school hebben voordelen en nadelen, dus leraren moeten goed nadenken over het gebruik.", "Tablets zijn slecht voor kinderen.", "Alle scholen moeten tablets gebruiken.", "Kinderen leren alleen door spelletjes te spelen."],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Hoofdgedachte bij voor- en nadelen",
            "content": "Als een tekst zowel voordelen als nadelen noemt, is de hoofdgedachte vaak een afweging — niet alleen positief of alleen negatief. Zoek de conclusie van de schrijver.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "main_idea_balanced",
      "variantIndex": 3,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Als een tekst zowel voordelen als nadelen noemt, is de hoofdgedachte een afweging. De tekst noemt voordelen (leren met spelletjes), nadelen (afleiding, schermtijd) en een conclusie (leraren moeten nadenken). De hoofdgedachte combineert alle drie.",
        "solutionSteps": [
          "Voordelen: leren met spelletjes (rekenen, taal)",
          "Nadelen: afleiding, te veel schermtijd",
          "Conclusie van de tekst: leraren moeten goed nadenken",
          "Hoofdgedachte = voordelen + nadelen + conclusie"
        ],
        "distractorExplanations": {
          "0": "Goed! De hoofdgedachte combineert de voordelen, nadelen en conclusie van de tekst.",
          "1": "Je dacht waarschijnlijk dat de tekst alleen negatief is over tablets. Maar de tekst noemt ook voordelen (leren met spelletjes). De hoofdgedachte is genuanceerd: zowel voor- als nadelen. Onthoud: lees de hele tekst, niet alleen een deel.",
          "2": "Je dacht waarschijnlijk dat de tekst alleen positief is over tablets. Maar de tekst noemt ook nadelen (afleiding, schermtijd) en een waarschuwing. Onthoud: de hoofdgedachte dekt de hele tekst.",
          "3": "Je dacht waarschijnlijk dat spelletjes het belangrijkste punt zijn. Maar spelletjes worden als één voordeel genoemd, niet als de hoofdgedachte. De tekst gaat breder: over het afwegen van voor- en nadelen. Onthoud: een detail is niet de hoofdgedachte."
        }
      }
    },
    {
      "id": "TAA-LEZEN-KERN-004",
      "familyId": "TAA-LEZEN-KERN",
      "module": "Taalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_hoofdgedachte",
      "questionType": "multiple_choice",
      "context": "Plastic afval is een groot probleem voor de oceanen. Elk jaar belandt er miljoenen kilo's plastic in zee. Zeeschildpadden en vissen eten het plastic per ongeluk op. Gelukkig zijn er steeds meer mensen en organisaties die het plastic opruimen en minder plastic willen gebruiken.",
      "question": "Welke titel past het best bij deze tekst?",
      "options": ["Plastic in de oceaan: een probleem met hoop op verbetering", "Zeeschildpadden: bedreigde dieren", "Waarom we meer plastic moeten maken", "Het leven onder water"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Titel als hoofdgedachte",
            "content": "Een goede titel vat de hoofdgedachte samen — niet te breed, niet te smal, en kloppend met de inhoud. De tekst gaat over het plasticprobleem én de hoop op verbetering.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "main_idea_title",
      "variantIndex": 4,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Een goede titel vat de hoofdgedachte samen. De tekst gaat over het plasticprobleem in oceanen (probleem) én opruimacties en minder plastic (hoop). Titel A dekt beide aspecten: 'een probleem' + 'hoop op verbetering'.",
        "solutionSteps": [
          "Zoek de hoofdpunten: (1) plastic is een probleem, (2) er is hoop door opruimacties",
          "Controleer elke titel: dekt deze beide punten?",
          "Titel A dekt zowel het probleem als de hoop ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Deze titel dekt zowel het probleem (plastic in de oceaan) als de hoop (verbetering door opruimacties).",
          "1": "Je dacht waarschijnlijk dat zeeschildpadden het hoofdonderwerp zijn. Maar zeeschildpadden worden als voorbeeld genoemd. De tekst gaat breder over plastic in de oceaan. Onthoud: een goede titel dekt de hele tekst, niet één detail.",
          "2": "Je dacht waarschijnlijk dat dit in de tekst staat. Maar de tekst zegt juist dat we minder plastic moeten gebruiken, niet meer. Dit is het tegenovergestelde. Onthoud: lees de tekst zorgvuldig.",
          "3": "Je dacht waarschijnlijk dat deze titel breed genoeg is. Maar 'Het leven onder water' is te vaag en dekt niet de kern (het plasticprobleem). Onthoud: een goede titel is specifiek genoeg om de inhoud te voorspellen."
        }
      }
    },
    {
      "id": "TAA-LEZEN-KERN-005",
      "familyId": "TAA-LEZEN-KERN",
      "module": "Taalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_hoofdgedachte",
      "questionType": "multiple_choice",
      "context": "In de middeleeuwen leefden ridders op kastelen. Ze droegen zware harnassen en vochten met zwaarden en lansen. Ridders moesten jarenlang trainen voordat ze ridder werden. Ze begonnen als page, werden daarna schildknaap, en pas dan mochten ze ridder worden.",
      "question": "Wat is de hoofdgedachte van deze tekst?",
      "options": ["Ridders leefden op kastelen en moesten lang trainen om ridder te worden.", "Ridders waren altijd in oorlog.", "Kastelen waren de mooiste gebouwen in de middeleeuwen.", "Iedereen kon ridder worden in de middeleeuwen."],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Hoofdgedachte herkennen",
            "content": "De hoofdgedachte is de belangrijkste boodschap van de hele tekst. Zoek de rode draad: welke informatie komt in alle zinnen terug? De tekst vertelt over het leven van ridders én hun lange opleiding.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "main_idea_historical",
      "variantIndex": 5,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "De hoofdgedachte is de rode draad door de hele tekst. De tekst vertelt over twee dingen: (1) hoe ridders leefden (kastelen, harnassen, wapens) en (2) hoe je ridder werd (page → schildknaap → ridder). De hoofdgedachte combineert beide.",
        "solutionSteps": [
          "Zoek de rode draad: waar gaat elke zin over?",
          "Punt 1: het leven van ridders (kastelen, harnassen)",
          "Punt 2: het trainingsproces (page → schildknaap → ridder)",
          "Hoofdgedachte: ridders leefden op kastelen en moesten lang trainen"
        ],
        "distractorExplanations": {
          "0": "Goed! De tekst gaat over het leven van ridders én hun lange opleiding.",
          "1": "Je dacht waarschijnlijk dat ridders alleen maar vochten. Maar de tekst noemt vechten als één aspect. De hoofdgedachte is breder: leven én opleiding. Onthoud: een detail is niet de hoofdgedachte.",
          "2": "Je dacht waarschijnlijk dat kastelen het hoofdonderwerp zijn. Maar de tekst noemt kastelen als woonplaats, niet als 'mooiste gebouwen'. Dat is een mening die niet in de tekst staat. Onthoud: de hoofdgedachte staat in de tekst.",
          "3": "Je dacht waarschijnlijk dat iedereen ridder kon worden. Maar de tekst zegt juist dat je jarenlang moest trainen (page → schildknaap → ridder). Niet iedereen kon zomaar ridder worden. Onthoud: lees de tekst zorgvuldig."
        }
      }
    }
  ]
}